<template>
  <v-dialog v-model="dialogMsg" max-width="600px" persistent>
    <v-card elevation="0">
      <v-card-title>
        <span class="textoUser" :style="`color:${this.color};`">{{this.titulo}}</span>
      </v-card-title>
      <v-card-text style="padding-bottom: 0px">
        <p class="textoUser" style="text-size: 12px; margin: 0px">{{this.mensagem}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn text color="primary" dark @click="close()">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        color: '',
        mensagem: '',
        titulo: '',
        top: true,
        right: false,
        snackbar: false,
        dialogMsg: false
      }
    },

    methods: {
      snackOld(cor, msg) {
        this.top = true
        this.right = true
        this.color = cor
        this.mensagem = msg
        this.snackbar = true
      },

      close() {
        this.dialogMsg = false
      },

      snack(cor,msg,tit) {
        this.titulo = tit
        this.color = cor
        this.mensagem = msg
        this.dialogMsg = true
      },
    }
  }
</script>

<style>

</style>
